import { render, staticRenderFns } from "./ConfigGP4BC.vue?vue&type=template&id=ed1a9b8a&scoped=true&"
import script from "./ConfigGP4BC.vue?vue&type=script&lang=js&"
export * from "./ConfigGP4BC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1a9b8a",
  null
  
)

export default component.exports